import { createAsyncThunk } from "@reduxjs/toolkit";
import { trackPromise } from "react-promise-tracker";
import { fetchWrapper } from "_utils";
import { PORTAL_KEY as name } from "constants/labels";

const baseUrl = `${process.env.REACT_APP_API_URL}/api/account-inquiry`;

export const getAIAgenciesApi = createAsyncThunk(
  `${name}/getAIAgencies`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.get(`${baseUrl}/manage-agency`)
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createAIAgencyApi = createAsyncThunk(
  `${name}/createAIAgency`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/manage-agency/create`, payload)
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateAIAgencyApi = createAsyncThunk(
  `${name}/updateAIAgency`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/manage-agency/update`, payload)
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteAIAgencyApi = createAsyncThunk(
  `${name}/deleteAIAgency`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.delete(`${baseUrl}/manage-agency/delete`, payload)
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);